if (!customElements.get('waitlist-form')) {
  class WaitlistForm extends HTMLElement {
    constructor() {
      super();
      this.delay = 3000;
      this.form = this.querySelector('form');
      this.selectVariants = this.querySelector('#variants');
    }

    toggleAlertMessage(success = false) {
      const message = this.querySelector(success ? '#completed_message' : '#error_message');
      if (!message) return;
      message.style.display = 'unset';
      setTimeout(() => (message.style.display = 'none'), this.delay);
    }

    onSubmitHandler(event) {
      event.preventDefault();

      const formData = new FormData(event.target);
      let currentFormData = Object.fromEntries(formData);

      let payloadBIS = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: `${currentFormData.bis_email}`,
                },
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `${currentFormData.platform}:::$default:::${currentFormData.bis_variant_id}`,
              },
            },
          },
        },
      };

      this.postRequest(this.form.action, payloadBIS, currentFormData.bis_account_id);

      // if(currentFormData.accepts_marketing && currentFormData?.bis_list_id?.length > 0){
      //   let payloadSubscribe = {
      //     data: {
      //       type: 'subscription',
      //       attributes: {
      //         profile: {
      //           data: {
      //             type: 'profile',
      //             attributes: {
      //               email: `${currentFormData.bis_email}`,
      //               properties: {
      //                 origin: "Back In Stock"
      //               }
      //             }
      //           }
      //         }
      //       },
      //       relationships: {
      //         list: {
      //           data: {
      //             type: 'list',
      //             id: `${currentFormData.bis_list_id}`
      //           }
      //         }
      //       }
      //     }
      //   }

      //   this.postRequest('https://a.klaviyo.com/client/subscriptions/',payloadSubscribe,currentFormData.bis_account_id);
      // }
    }

    postRequest(action, payload, accountID) {
      if (!action || !payload || !accountID) return;

      const payloadObject = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          revision: '2024-06-15',
          'Content-Type': 'application/json',
        },
      };


      fetch(`${action}?company_id=${accountID}`, payloadObject)
        .then((response) => {
          if (!response.ok) {
            this.toggleAlertMessage();
            throw new Error(response.statusText);
          }

          this.toggleAlertMessage(true);
        })
        .catch((err) => console.error('Klaviyo waitlist form is not submitted', err));
    }

    connectedCallback() {
      this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmitHandler.bind(this));
    }
  }

  customElements.define('waitlist-form', WaitlistForm);
}
